// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject5":"Pokedex-module--seeLiveProject5--3FEoY","sourceCodeProject5":"Pokedex-module--sourceCodeProject5--3GXzU"};